export const FLUSS_TASK_MAIN_WIDTH_KEY = "fluss-task.main-width";
export const FLUSS_TASK_MAIN_WIDTH_DEFAULT = 58;
export const FLUSS_TASK_MAIN_WIDTH_MIN = 35;
export const FLUSS_TASK_MAIN_WIDTH_MAX = 75;

export const clampTaskMainWidth = (width: number) =>
    Math.min(FLUSS_TASK_MAIN_WIDTH_MAX, Math.max(FLUSS_TASK_MAIN_WIDTH_MIN, width));

const userWidthKey = (userId?: string) => `${FLUSS_TASK_MAIN_WIDTH_KEY}.${userId || "anonymous"}`;

export const loadTaskMainWidth = (userId?: string, storage?: Pick<Storage, "getItem">) => {
    try {
        const stored = (storage || (typeof window === "undefined" ? undefined : window.localStorage))?.getItem(userWidthKey(userId));
        const width = Number(stored);
        return stored && Number.isFinite(width) ? clampTaskMainWidth(width) : FLUSS_TASK_MAIN_WIDTH_DEFAULT;
    } catch {
        return FLUSS_TASK_MAIN_WIDTH_DEFAULT;
    }
};

export const saveTaskMainWidth = (width: number, userId?: string, storage?: Pick<Storage, "setItem">) => {
    try {
        (storage || (typeof window === "undefined" ? undefined : window.localStorage))?.setItem(userWidthKey(userId), String(clampTaskMainWidth(width)));
    } catch {
        // Private browsing and restricted storage still allow resizing in this session.
    }
};
